export const importHistoryActions = Object.freeze({
  IMPORT_HISTORY_FETCH_IMPORTS: 'IMPORT_HISTORY_FETCH_IMPORTS',
  IMPORT_HISTORY_TABLE_UPDATE_PAGE: 'IMPORT_HISTORY_TABLE_UPDATE_PAGE',
  IMPORT_HISTORY_TABLE_UPDATE_PAGE_SIZE: 'IMPORT_HISTORY_TABLE_UPDATE_PAGE_SIZE',
  IMPORT_HISTORY_TABLE_BUILD_IMPORTS: 'IMPORT_HISTORY_TABLE_BUILD_IMPORTS,',
  IMPORT_HISTORY_UPDATE_IMPORTS: 'IMPORT_HISTORY_UPDATE_IMPORTS,',
});
